module.exports = function () {
    if ($('.locations-listing').length === 0) {
        return;
    }

    var loadMap = function ($placeholder, location) {
        var mapOptions = {
            zoom: 13,
            key: window.ICFGoogleMapsKey,
            center: location,
            size: '247x163',
            markers: location
        };

        var mapOptionsQuery = Object.keys(mapOptions).filter(function (key) {
            return mapOptions.hasOwnProperty(key);
        }).map(function (key) {
            return key + '=' + encodeURIComponent(mapOptions[key].toString());
        }).join('&');

        var $mapItem = $('<img style="width: 100%; height: auto; border: none;" src="https://maps.googleapis.com/maps/api/staticmap?' + mapOptionsQuery + '"/>');
        $placeholder.parent().append($mapItem);

        $mapItem[0].onload = function() {
            $placeholder.remove();
        };
    };

    var id = window.location.hash.substring(1);

    if (id.length) {
        $('.locations-listing-tab-content-location-active').removeClass('locations-listing-tab-content-location-active');
        var $locationItem = $('[data-id="' + id + '"]');
        $locationItem.addClass('locations-listing-tab-content-location-active');

        $locationItem.find('[data-location]').each(function () {
            var $container = $(this);
            var $placeholder = $container.find('.locations-listing-tab-content-location-image-placeholder');
            if ($placeholder.length) {
                loadMap($placeholder, $container.data('location'));
            }
        });

        $('.locations-listing-tab-content-active').removeClass('locations-listing-tab-content-active');
        var $regionTabContent = $locationItem.parents('.locations-listing-tab-content').first();
        $regionTabContent.addClass('locations-listing-tab-content-active');

        $('.locations-listing-tab-active').removeClass('locations-listing-tab-active');
        var $tabItem = $('[data-reference="' + $regionTabContent.data('id') + '"]');
        $tabItem.addClass('locations-listing-tab-active');

        history.replaceState("", document.title, window.location.pathname + window.location.search);
    }

    $('.locations-listing-tab').click(function() {
        $('.locations-listing-tab-active').removeClass('locations-listing-tab-active');
        $(this).addClass('locations-listing-tab-active');

        var reference = $(this).data('reference');
        var $referencedTab = $('[data-id="' + reference + '"]');

        $('.locations-listing-tab-content-active').removeClass('locations-listing-tab-content-active');
        $referencedTab.addClass('locations-listing-tab-content-active');
    });

    $('.locations-listing-tab-content-location-title').click(function () {
        var $clickedLocation = $(this).parents('.locations-listing-tab-content-location').first();

        if ($clickedLocation.hasClass('locations-listing-tab-content-location-active')) {
            $clickedLocation.removeClass('locations-listing-tab-content-location-active');
        } else {
            $('.locations-listing-tab-content-location-active').removeClass('locations-listing-tab-content-location-active');
            $clickedLocation.addClass('locations-listing-tab-content-location-active');

            $clickedLocation.find('[data-location]').each(function () {
                var $container = $(this);
                var $placeholder = $container.find('.locations-listing-tab-content-location-image-placeholder');
                if ($placeholder.length) {
                    loadMap($placeholder, $container.data('location'));
                }
            });
        }
    });

    var resortLocations = function($locations, $parent) {
        $locations.sort(function(a, b) {
            if (!$(a).is(':visible')) {
                return 1;
            }
            else if (!$(b).is(':visible')) {
                return -1;
            } else {
                return $(a).find('.locations-listing-tab-content-location-title').text() >
                    $(b).find('.locations-listing-tab-content-location-title').text() ? 1: -1;
            }
        }).appendTo($parent);
    }

    $('.locations-listing-tab-content-subregion').click(function() {
        var $container = $(this).parents('.locations-listing-tab-content').first();

        $container.find('.locations-listing-tab-content-subregion-selected').removeClass('locations-listing-tab-content-subregion-selected');
        $container.find('.locations-listing-tab-content-subregion[data-subregion-id="' + $(this).data('subregionId') + '"]').addClass('locations-listing-tab-content-subregion-selected');

        if ($(this).data('subregionId') === 'all') {
            $container.find('.locations-listing-tab-content-location').show();
        } else {
            $container.find('.locations-listing-tab-content-location').hide();
            $container.find('.locations-listing-tab-content-location[data-subregion-id="' + $(this).data('subregionId') + '"]').show();
        }

        var $locations = $container.find('.locations-listing-tab-content-location');

        resortLocations($locations, $locations.first().parent());
        $(window).resize();
    });

    var resizeLocationInfo = function() {
        $('.locations-listing-tab-content-location').each(function () {
            var $location = $(this);
            var height = $location.find('.locations-listing-tab-content-location-content').outerHeight() + 56;
            $location.css('height', height + 'px');
        });
    };

    resizeLocationInfo();
    setTimeout(resizeLocationInfo, 100);
    $(window).resize(resizeLocationInfo);
};